import { appid, storeKey } from '../constants/common';
import filterUrl from '@/utils/filterUrl';

let wechat = null;

export const wechatInit = () => {
  let config = {
    debug: false,
    jsApiList: [
      'checkJsApi',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'openCard',
      'addCard'
    ]
  };
  wechat = new Wechat(appid).config(config);
  return wechat;
};

wx.ready(() => {
  let bgm = document.getElementById('bgm');
  bgm.play();
});

export const wechatGetUserInfo = () => {
  return new Promise((resolve, reject) => {
    wechat.getUserInfo(function(err, res) {
      if (err) {
        reject(err);
      }
      localStorage.setItem(storeKey, JSON.stringify(res));
      resolve(res);
    });
  });
};

export const wechatBaseAuth = () => {
  try {
    wechat.goTwoAuth('snsapi_base', 'STATE', wechat.filter(['code']));
  } catch (e) {
    console.warn(e);
  }
};

export const wechatUserInfoAuth = () => {
  try {
    wechat.goTwoAuth('snsapi_userinfo', 'STATE', wechat.filter(['code']));
  } catch (e) {
    console.warn(e);
  }
};

// 添加卡券
export const wxAddCard = (card, successCb) => {
  try {
    wx.addCard({
      cardList: [card],
      success: successCb
    });
  } catch (e) {
    console.warn(e);
  }
};

// 查看卡券
export const wxOpenCard = card => {
  console.log(card);
  try {
    wx.openCard({
      cardList: [card]
    });
  } catch (e) {
    console.warn(e);
  }
};

export const wxCloseWindow = () => {
  wx.closeWindow();
};

export const initWxShare = () => {
  wx.ready(function() {
    let title = '此生无悔入暴雪，召唤兄弟领福利！';
    let link = fiboSDK.dealUrl(filterUrl(location.href,['code']));
    let imgUrl = require('../assets/images/share/share.jpg');
    let desc = '海澜之家x暴雪娱乐合作系列热血上市，抢超值预售礼券！';

    imgUrl = location.origin + '/hla-baoxue-h5/' + imgUrl;
    console.log(imgUrl);

    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function() {
        fiboSDK.share('friend');
        console.log('share friend');
      }
    });

    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function() {
        fiboSDK.share('timeline');
        console.log('share timeline');
      }
    });
  });
};
